export default __webpack_public_path__ + "static/media/LSTM-CNN.53f2e082.png";